/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Share_Code_ExampleInputs */



/**
* | output |
* | --- |
* | "e.g. 32a9599f-9670-47a1-8746-1cd0591f3262" |
*
* @param {Team_Project_Import_Share_Code_ExampleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_share_code_example = /** @type {((inputs?: Team_Project_Import_Share_Code_ExampleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Share_Code_ExampleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ex. 32a9599f-9670-47a1-8746-1cd0591f3262")
	if (locale === "de") return /** @type {LocalizedString} */ ("z.B. 32a9599f-9670-47a1-8746-1cd0591f3262")
	if (locale === "it") return /** @type {LocalizedString} */ ("per esempio. 32a9599f-9670-47a1-8746-1cd0591f3262")
	if (locale === "ru") return /** @type {LocalizedString} */ ("например 32a9599f-9670-47a1-8746-1cd0591f3262")
	if (locale === "es") return /** @type {LocalizedString} */ ("p.ej. 32a9599f-9670-47a1-8746-1cd0591f3262")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("例如32a9599f-9670-47a1-8746-1cd0591f3262")
	if (locale === "ja") return /** @type {LocalizedString} */ ("例えば32a9599f-9670-47a1-8746-1cd0591f3262")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जैसे 32a9599f-9670-47a1-8746-1cd0591f3262")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("por exemplo 32a9599f-9670-47a1-8746-1cd0591f3262")
	return /** @type {LocalizedString} */ ("e.g. 32a9599f-9670-47a1-8746-1cd0591f3262")
});